import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { DigitalCard } from '../components/carte/DigitalCard';
import { FamilySection } from '../components/carte/FamilySection';
import { PetsSection } from '../components/carte/PetsSection';
import { ConsentDialog, EditCardDialog } from '../components/carte/EditCardDialog';
import { AssetsSection } from '../components/carte/AssetsSection';
import { properties, vehicles } from '../data/carte';
import type { FamilyMember } from '../data/carte';
export function MaCarte() {
  const [memberId, setMemberId] = useState('charlotte');
  const [editing, setEditing] = useState<FamilyMember | null>(null);
  const [consent, setConsent] = useState<FamilyMember | null>(null);

  // `/ma-carte#animaux` (raccourcis de Mon profil) : défile jusqu'à la section demandée.
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const timer = window.setTimeout(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 80);
    return () => window.clearTimeout(timer);
  }, [hash]);
  const openEdit = (member: FamilyMember) => {
    if (member.canEdit) setEditing(member);else setConsent(member);
  };
  return <main className="bg-white" data-id="element-3129" data-mp="2bxfeep715zdr">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-3130" data-mp="26vzu4zcofwwf">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-3131" data-mp="26y2ti9zpz2dt">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-3132" data-mp="223orvpugrz0p">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-3133" data-mp="1t5d4rxst3jd0" />
          <span aria-current="page" data-id="element-3134" data-mp="1t30d2sx8xumr">Ma carte</span>
        </nav>

        <header className="mt-4" data-id="element-3135" data-mp="1o4ffl19dpp20">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-3136" data-mp="1o7l0s5ew06sg">Ma carte</h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-3137" data-mp="19j1iovwu6dl5">
            Votre carte citoyenne numérique donne accès aux services municipaux pour vous et les membres de votre
            famille.
          </p>
        </header>

        <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,460px)_minmax(0,1fr)] lg:gap-14" data-id="element-3138" data-mp="10joiktulr1d3">
          <DigitalCard memberId={memberId} onEdit={openEdit} data-id="element-3139" data-mp="14kq82iypvz1v" />
          <div data-id="element-3140" data-mp="1s9t1sp6mlicq">
            <FamilySection selectedId={memberId} onSelect={setMemberId} data-id="element-3141" data-mp="1s99hx2xf0jw2" />
            <PetsSection data-id="element-3142" data-mp="1x8cncohb4s4k" />
            <AssetsSection id="proprietes" title="Mes propriétés" items={properties} data-id="element-3143" data-mp="1x8vx3hwt0a7i" />
            <AssetsSection id="vehicules" title="Mes véhicules" items={vehicles} data-id="element-3144" data-mp="1jhr2wvc7ga4k" />
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-3145" data-mp="1nhi0bhw8loi2">
        {editing && <EditCardDialog member={editing} onClose={() => setEditing(null)} data-id="element-3146" data-mp="1ngq6ocm7a0uf" />}
      </AnimatePresence>
      <AnimatePresence data-id="element-3147" data-mp="2b6ar6zy0565t">
        {consent && <ConsentDialog member={consent} onClose={() => setConsent(null)} data-id="element-3148" data-mp="2fzndh3f7l0ve" />}
      </AnimatePresence>
    </main>;
}